import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'redux-form/immutable';
import messages from '../messages';
import { RadioPublicButton, SimpleInput } from '../field-components';
import { required, requiredRadioButton, validateCollectionMembersCount } from '../validators';

function AppealCollectivity({ formName, value }) {
  const isCollective = Boolean(+value);

  return (
    <React.Fragment>
      <div className="item clearfix">
        <label className="form-label text-left col-md-3" style={{ lineHeight: '20px' }}>
          <FormattedMessage {...messages.is_collective} />
        </label>
        <Field
          labelStyle={{
            marginRight: '20px',
            marginLeft: '20px',
            lineHeight: 'inherit',
          }}
          name={`${formName}[is_collective]`}
          validate={[requiredRadioButton]}
          component={RadioPublicButton}
          inputValue={1}
          label={<FormattedMessage {...messages.yes} />}
        />
        <Field
          labelStyle={{
            marginRight: '20px',
            marginLeft: '20px',
            lineHeight: 'inherit',
          }}
          name={`${formName}[is_collective]`}
          validate={[requiredRadioButton]}
          component={RadioPublicButton}
          inputValue={0}
          label={<FormattedMessage {...messages.no} />}
        />
      </div>

      {isCollective && (
        <div className="item clearfix">
          <label className="form-label text-left col-md-3" style={{ lineHeight: 1.5 }}>
            <FormattedMessage {...messages.collection_members_count} />
          </label>
          <Field
            name={`${formName}[collection_members_count]`}
            validate={[required, validateCollectionMembersCount]}
            component={SimpleInput}
            type="number"
          />
        </div>
      )}
    </React.Fragment>
  );
}

export default AppealCollectivity;



// WEBPACK FOOTER //
// ./src/application-form/sections/appeal-collectivity.js